import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";

@Injectable()
export class GlobalSearchService {
    constructor(private http: HttpClient) {}

    getSearchResults(pageNo, pageSize, searchValue, sortBy, isAscending) {
        let params = new HttpParams();
        params = params.append("PageNumber", pageNo);
        params = params.append("PageSize", pageSize);
        params = params.append("SortBy", sortBy);
        params = params.append("IsAscending", isAscending);
        return this.http
            .get<any>(
                `${environment.coreUrl}GlobalSearch?SearchValue=${encodeURIComponent(searchValue)}`,
                { observe: "response", params }
            )
            .toPromise()
            .then((res) => ({
                data: res.body,
                headers: JSON.parse(res.headers.get("x-pagination")), //{TotalCount: 91, PageSize: 10, CurrentPage: 1, TotalPages: 10, HasNext: true, HasPrevious: false}
            }));
    }
}
